import React from 'react';

//CORE COMPOENTNS
import { ThemeProvider } from '../../../components-core/packages/components-core/dist/theme-provider';
import styled from 'styled-components';

//LAYOUT
import {
    Container,
    ContainerGutter,
    ContainerWrap,
    ContainerPadding
} from '../../../components-core/packages/components-core/dist/container';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';

//STYLE
import { Text, TextAppearance } from '../../../components-core/packages/components-core/dist/text';
import { Button, ButtonAppearance } from '../../../components-core/packages/components-core/dist/button'
import backgroundImageUrl from './Fuar_GORSEL.jpg'

const BackgroundImageContainer = styled.div`
    height: 100vh;
    width: 100vw;
    background-image: url(${props => props.backgroundImageUrl && props.backgroundImageUrl});
    background-position: center;
    background-size: cover;
    background-blend-mode: overlay;
    object-fit: cover;

`;

const GeneralContainer = styled.div`
    z-index: 1;
    position: relative;
`;

const TopContainer = styled.div`
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: flex-end;
    position: absolute;
    overflow: hidden;

    z-index: 1;
`;


class BannerComponent extends React.Component {

    constructor() {
        super();

    }
    renderTextContainer() {

        return (
            <Container wrap={ContainerWrap.always} >

                <Text appearance={TextAppearance.copy0250}><br/>
                    Yeni Caddy ve Volkswagen Ticari Araç Camper <br/>modelleri sanal fuar ile karşınızda.
                </Text>
            </Container>
        )
    }

    render() {


        return (
            <ThemeProvider theme={'image'}>
                <GeneralContainer>
                    <TopContainer>
                        <Container
                            wrap={ContainerWrap.always}
                            padding={containerPadding}
                            gutter={ContainerGutter.dynamic0200}
                        >
                            {this.renderTextContainer()}

                            <Button appearance={ButtonAppearance.Primary}>
                            <a href="https://www.volkswagen-nutzfahrzeuge.de/app/virtuelle-messe/index.html" style={{textDecoration:'none', color: 'black'}}>Gezmek için tıklayın</a>
                            </Button>

                        </Container>
                    </TopContainer>
                </GeneralContainer>
                <BackgroundImageContainer
                    backgroundImageUrl={backgroundImageUrl}
                />
            </ThemeProvider>
        )
    }
}


const containerPadding = {
    left: {
        [Breakpoints.default]: ContainerPadding.dynamic0200,
        [Breakpoints.b560]: ContainerPadding.dynamic0250,
        [Breakpoints.b960]: ContainerPadding.dynamic0350
    },
    right: ContainerPadding.dynamic0300,
    bottom: {
        [Breakpoints.default]: ContainerPadding.dynamic0350,
        [Breakpoints.b560]: ContainerPadding.dynamic0450
    }
}
export default BannerComponent;